export default __webpack_public_path__ + "static/media/missing.0b7b92c0.svg";